import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './assets/styles.css';
import './assets/fonts.css';

import { GoogleReCaptchaProvider } from './providers/GoogleReCaptchaProvider/GoogleReCaptchaProvider';
import { preloader } from './services/preloader';

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

await preloader();

createRoot(container).render(
  <React.StrictMode>
    <GoogleReCaptchaProvider>
      <App />
    </GoogleReCaptchaProvider>
  </React.StrictMode>,
);
